import { api } from '../api';
import { CONTRACT_PATH_LIST, CONTRACT_PATH, REQUESTER_PATH, SCRIPT_RENEWAL_PATH } from '../endpoints';
import { SET_CONTRACTS } from '~/store/feature/Contracts';
import { getHeaders } from '../generics/Header';
import { FormScript, GlobalResponse } from '~/models/Commons ';
import { ScriptRenewalRequest } from '~/models/types/ContractsTypes';

const extendedApiSlice = api.injectEndpoints({
    endpoints: (builder) => ({
        getContracts: builder.query<
            GlobalResponse<any[]>,
            { page: number; size: number }
        >({
            query: ({ page, size }) => ({
                url: `${CONTRACT_PATH_LIST}?page=${page}&size=${size}`,
                method: 'GET',
                credentials: 'include',
                headers: getHeaders(),
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    dispatch(SET_CONTRACTS(data.payload));
                } catch (error) {
                    console.error('Error fetching contracts:', error);
                }
            },
        }),

        deleteContracts: builder.mutation<GlobalResponse<FormScript>, string>({
            query: (requesterUniqueId) => ({
                url: `${CONTRACT_PATH}/${requesterUniqueId}`,
                method: 'DELETE',
                credentials: 'include',
                headers: getHeaders(),
            }),
        }),

        triggerRequester: builder.mutation<GlobalResponse<null>, string>({
            query: (requesterId) => ({
                url: `${REQUESTER_PATH}/${requesterId}/trigger`,
                method: 'POST',
                credentials: 'include',
                headers: getHeaders(),
            }),
        }),

        renewalScript: builder.mutation<GlobalResponse<{ renewalRequestId: string }>, ScriptRenewalRequest>({
            query: (body) => ({
                url: SCRIPT_RENEWAL_PATH,
                method: 'POST',
                credentials: 'include',
                headers: getHeaders(),
                body,
            }),
        }),
    }),
});

export const {
    useGetContractsQuery,
    useLazyGetContractsQuery,
    useDeleteContractsMutation,
    useTriggerRequesterMutation,
    useRenewalScriptMutation,
} = extendedApiSlice;